import React from 'react';
import Head from 'next/head';

interface OpenGraphKeywordsProps{
  // add open graph keywords props here
  keywords : string | Array<string>;

}

const OpenGraphKeywords: React.FC<OpenGraphKeywordsProps> = ({
  keywords,
}: OpenGraphKeywordsProps) => (
  <Head>
    <meta key="keywords" name="keywords" content={typeof keywords === 'string' ? keywords : keywords.join(', ')} />
  </Head>
);

export default OpenGraphKeywords;
